import React from "react";

const VideoConf = () => {
  return (
    <div>
      <ol type="1">
        <h2>Video Conferencing</h2>
        <li className="list">
          Surgery-theater: IP: 170.212.61.1 Subnet: 255.255.254.0 Gateway:
          170.212.60.2
        </li>

        <li className="list">
          Silver 6: 170.212.62.91 Subnet mask: 255.255.254 Gateway: 170.212.62.2
          1002
        </li>

        <li className="list">Silver 4 (JAM): 170.212.63.224</li>

        <li className="list">
          Pennsylvania Hospital: (Neuro Conf Room): 170.166.141.118
        </li>

        <li className="list">Presby Conf Room: 170.212.97.214</li>

        <li className="list">The Presby Auditorium: 170.212.192.211</li>

        <li className="list">
          Presby Cardiovascular conf room: 170.212.194.210
        </li>

        <li className="list">Pocono 209.173.13.178</li>

        <li className="list">
          The Reading Hospital and Medical Center: 205.147.237.30
        </li>

        <li className="list">Cardiac Conf room (2pcam): 128.91.142.138</li>

        <li className="list">
          Cath Lab #1: 170.166.111.171 255.255.252.0 170.166.108.2
        </li>

        <li className="list">PAH Surgery: 170.166.68.230</li>

        <li className="list">Garfield Duncan 4th Floor:170.166.140.81</li>

        <li className="list">Rhoads 5: 170.212.69.235</li>

        <li className="list">
          Presby PAC3 10.170.157.203, PAC4 10.170.159.199, 1MOB 10.170.163.234
        </li>

        <li className="list">PAH (Jim Henry's area): 170.166.68.230</li>

        <li className="list">SIM Center: 170.212.175.242</li>
      </ol>
    </div>
  );
};
export default VideoConf;
